/** @format */

import React from "react";
import Head from "next/head";
import { useDispatch } from "react-redux";
import { updateMapLoadingStatus } from "core-lib/reduxStore/layout/action";
import Script from "next/script";

const SCRIPT_ID = "google_map_script_id";
// @ts-ignore
const SCRIPT_SOURCE = `https://maps.google.com/maps/api/js?libraries=geometry,places&key=${process.env.GOOGLE_MAP_API_KEY}`;
export function GoogleMapScript() {
  const dispatch = useDispatch();

  return (
    <>
      <Head>
        <link rel="dns-prefetch" href="https://maps.google.com" />
        <link rel="preconnect" href="https://maps.google.com" />
      </Head>
      <Script
        onError={() => {
          dispatch(updateMapLoadingStatus({ status: "failure" }));
        }}
        src={SCRIPT_SOURCE}
        id={SCRIPT_ID}
        onLoad={() => {
          dispatch(updateMapLoadingStatus({ status: "success" }));
        }}
      />
    </>
  );
}

export default GoogleMapScript;
